import { useEffect, useState } from 'react';
/**
 * This hook returns whether the provided element is wider than the provided width.
 *
 * You can pass in either a ref or a selector string to the hook. If you pass in a ref, the hook will return the width
 * of the element referenced by the ref. If you pass in a selector string, the hook will return the width of the first
 * element that matches the selector.
 *
 * It uses the resize observer API to monitor the width of the element and update the state accordingly.
 *
 * @param {string | React.RefObject<HTMLElement>} elementRefOrSelector
 * @param {number} width The width in pixels to compare the element to
 * @returns {boolean} Whether the element is wider than the provided width
 */
function useElementWiderThan(elementRefOrSelector, width) {
    var element = typeof elementRefOrSelector === 'string'
        ? document.querySelector(elementRefOrSelector)
        : elementRefOrSelector.current;
    var _a = useState(function () {
        return (element === null || element === void 0 ? void 0 : element.clientWidth) > width;
    }), wider = _a[0], setWider = _a[1];
    useEffect(function () {
        if (!element) {
            console.warn('useElementWiderThan: element not found');
            return;
        }
        var resizeObserver = new ResizeObserver(function (entries) {
            setWider(entries[0].contentRect.width > width);
        });
        resizeObserver.observe(element);
        return function () {
            resizeObserver.disconnect();
        };
    }, [element]);
    return wider;
}
export { useElementWiderThan };
